import Toggle from "react-dark-mode-toggle";
import useDarkMode from "@fisch0920/use-dark-mode";

const DarkModeToggle = () => {
	const darkMode = useDarkMode(true);
	return <Toggle onChange={darkMode.toggle} checked={darkMode.value} size={80} />;
};

export default DarkModeToggle;
